import { render, staticRenderFns } from "./Lgx02713975214849195507961.vue?vue&type=template&id=80fbe066&"
import script from "./Lgx02713975214849195507961.vue?vue&type=script&lang=js&"
export * from "./Lgx02713975214849195507961.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports